module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 04.a67dac55.svg";